
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { navMenuItems, getActiveNavTab } from '@/utils/navigationMenu';
import NavToggle from '@/components/NavToggle.vue';
export default {
  name: 'SidePanel',
  components: { NavToggle },
  setup() {
    const route = useRoute();

    const activeTab = computed(() => getActiveNavTab(route.name));

    const isSidebarToggled = ref(true);
    const menuItems = navMenuItems;
    const onSidebarToggle = () => {
      isSidebarToggled.value = !isSidebarToggled.value;
    };
    return { activeTab, menuItems, onSidebarToggle, isSidebarToggled };
  },
};
